import React, { Fragment } from "react"

import styles from "../styles/privacyPolicy.module.css"

export default function PrivacyPolicy({ show, hidePrivacy }) {
  const targetBgClass = show && styles.showBg
  const targetContainerClass = show && styles.showContainer
  return (
    <Fragment>
      <div
        className={[styles.background, targetBgClass].join(" ")}
        onClick={hidePrivacy}
      />
      <div className={[styles.container, targetContainerClass].join(" ")}>
        <div className={styles.header}>
          <h2 className={styles.title}>Privacy Policy</h2>
          <button type="button" onClick={hidePrivacy} className={styles.close}>
            &times;
          </button>
        </div>
        <div className={styles.content}>
          <strong>Privacy </strong>{" "}
          <p>
            Codaxe labs built the Meritas app as a Commercial app. This Service is
            provided by Codaxe labs and is intended for use as is.
          </p>{" "}
          <p>
            <strong>User Provided Information</strong>
          </p>{" "}
          <p>
            While using our Service, we may require you
            to provide us with certain personally identifiable information,
            including but not limited to email. The information that we request
            will be securely stored with our third party services.
          </p>{" "}
          <div>
            <p>
              The app uses third party services that may collect information
              used to identify you.
            </p>{" "}
            <p>
              Link to privacy policy of third party service providers used by
              the app
            </p>{" "}
            <ul>
              <li>
                <a
                  href="https://www.google.com/policies/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Play Services
                </a>
              </li>
              <li>
                <a
                  href="https://www.heroku.com/policy/security"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Heroku
                </a>
              </li>
            </ul>
          </div>{" "}
          <p>
            <strong>Service Providers</strong>
          </p>{" "}
          <p>
            We may employ third-party companies and individuals due to the
            following reasons:
          </p>{" "}
          <ul>
            <li>To facilitate our Service;</li>{" "}
            <li>To provide the Service on our behalf;</li>{" "}
            <li>To perform Service-related services; or</li>{" "}
            <li>To assist us in analyzing how our Service is used.</li>
          </ul>{" "}
          <p>
            We want to inform users of this Service that these third parties have
            access to your Personal Information. The reason is to perform the
            tasks assigned to them on our behalf. However, they are obligated
            not to disclose or use the information for any other purpose.
          </p>{" "}
          <p>
            <strong>Opt-out Rights</strong>
          </p>{" "}
          <p>
          You can stop all collection of information by the Service easily by uninstalling the app. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network. You can also request to opt-out via email, at codaxelabs@gmail.com.
          </p>{" "}
          <p>
            <strong>Data Retention Policy, Managing Information</strong>
          </p>{" "}
          <p>
          We will retain User Provided Information for as long as you use the app and for a reasonable time thereafter. If you’d like us to delete User Provided Information that you have provided via the app, please contact us at codaxelabs@gmail.com and we will respond in a reasonable time. Please note that some or all of the User Provided Information may be required in order for the app to function properly.
          </p>{" "}
          <p>
            <strong>Children’s Privacy</strong>
          </p>{" "}
          <p>
            These Services do not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from children
            under 13. In the case we discover that a child under 13 has provided
            us with personal information, we immediately delete this from our
            servers. If you are a parent or guardian and you are aware that your
            child has provided us with personal information, please contact us
            so that we will be able to do necessary actions.
          </p>{" "}
          <p>
            <strong>Security</strong>
          </p>{" "}
          <p>
            We value your trust in providing us your Personal Information, thus
            we are striving to use commercially acceptable means of protecting
            it. But remember that no method of transmission over the internet,
            or method of electronic storage is 100% secure and reliable, and we
            cannot guarantee its absolute security.
          </p>{" "}
          <p>
            <strong>Changes to This Privacy Policy</strong>
          </p>{" "}
          <p>
            We may update our Privacy Policy from time to time. Thus, you are
            advised to review this page periodically for any changes. We will
            notify you of any changes by posting the new Privacy Policy on this
            page.
          </p>{" "}
          <p>
            <strong>Your Consent</strong>
          </p>{" "}
          <p>
          If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing and improving the
            Service. We will not use or share your information with anyone except
            as described in this Privacy Policy.
          </p>{" "}
          <p>
            <strong>Contact Us</strong>
          </p>{" "}
          <p>
            If you have any questions or suggestions about our Privacy Policy, do
            not hesitate to contact us at codaxelabs@gmail.com.
          </p>{" "}
        </div>
      </div>
    </Fragment>
  )
}
